import httpService from "./httpService";

export default {
  findAllByVbIncomingDocId(vbIncomingDocId) {
    return httpService.get("/vbDocBccInfo/findAllByVbIncomingDocId", {
      params: {vbIncomingDocId: vbIncomingDocId}
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/vbDocBccInfoService.js